/* The search field inside the sheet. */

.wrap {
  padding: 0 16px 10px;
  flex: none;
}

.field {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.62);
  box-shadow: inset 0 0 0 0.5px rgba(11, 31, 23, 0.07);
  color: var(--ink-3);
}

.field svg {
  width: 17px;
  height: 17px;
  flex: none;
}

.field input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: none;
  outline: none;
  font-size: 16px;
  font-family: inherit;
  color: var(--ink);
  letter-spacing: -0.01em;
}

.field input::placeholder {
  color: var(--ink-3);
}

.field input::-webkit-search-cancel-button {
  display: none;
}

.clear {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgba(11, 31, 23, 0.12);
  color: #fff;
}

.clear svg {
  width: 12px;
  height: 12px;
  stroke-width: 2.6;
}
